export default "__VITE_ASSET__R5HQF0bl__"